import { makeBaseEntitiesState, makeDefaultEntitiesState } from '@modules/app-common/state/entities.state';
import { Action, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { FindCareerSurveysGQL, CareerSurveyData } from 'generated/graphql';
import { tap } from 'rxjs';

const CareerSurveysBaseEntitiesState = makeBaseEntitiesState<CareerSurveyData>('careerSurveys');

export class CareerSurveysFindManyAction {
  static readonly type = '[Career Surveys] Find Many';

  constructor() {}
}

@State({
  name: 'careerSurveys',
  defaults: makeDefaultEntitiesState(),
})
@Injectable()
export class CareerSurveysEntitiesState extends CareerSurveysBaseEntitiesState {
  private findCareerSurveysGQL = inject(FindCareerSurveysGQL);

  @Action(CareerSurveysFindManyAction)
  find(ctx: StateContext<any>, action: CareerSurveysFindManyAction) {
    return this.findCareerSurveysGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
      tap((result) => {
        this.patchEntities(ctx, result.data.findCareerSurveys as CareerSurveyData[]);
      })
    );
  }

  // @Action(CareerSurveyResultsGetStudentsAction)
  // getSurveyResultByUserId(ctx: StateContext<any>, action: CareerSurveyResultsGetStudentsAction) {
  //   return this.findCareerSurveyResultsGQL.fetch({ dto: { userId: action.payload.studentId } }, { fetchPolicy: 'no-cache' }).pipe(
  //     tap((result) => {
  //       this.patchEntities(ctx, result.data.findCareerSurveyResults as CareerSurveyResult[]);
  //     })
  //   );
  // }
  //
  // @Action(CareerSurveyResultsSaveAction)
  // save(ctx: StateContext<any>, action: CareerSurveyResultsSaveAction) {
  //   return this.saveCareerSurveyResultsGQL
  //     .mutate({
  //       dto: action.payload,
  //     })
  //     .pipe(
  //       tap((result) => {
  //         this.patchEntity(ctx, result?.data?.updateCareerSurveyResult as CareerSurveyResult);
  //       })
  //     );
  // }
}
